import { atom, useAtom } from "jotai";

import { type MMMNotification } from "../components/notifications/grouped-notifications";

const mmmNotificationAtom = atom<MMMNotification[]>([]);

export const useMMMNotifications = () => {
  return useAtom(mmmNotificationAtom);
};
